import { motion, useReducedMotion } from "framer-motion";
import { ShieldCheck, MapPin, Hammer } from "lucide-react";
import BlueprintBackground from "./BlueprintBackground";
import ContactActions from "./ContactActions";

const stagger = { animate: { transition: { staggerChildren: 0.12 } } };
const up = {
  initial: { opacity: 0, y: 22 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function AnimatedHero({ onStartChat, onHowItWorks }) {
  const reduce = useReducedMotion();
  const MV = reduce ? "div" : motion.div;
  const MH = reduce ? "h1" : motion.h1;
  const MP = reduce ? "p" : motion.p;

  return (
    <section className="relative overflow-hidden border-b border-white/5 px-6 pb-20 pt-28 md:pt-36">
      <BlueprintBackground />
      <MV
        variants={reduce ? undefined : stagger}
        initial={reduce ? undefined : "initial"}
        animate={reduce ? undefined : "animate"}
        className="relative z-10 mx-auto max-w-4xl"
      >
        <MV variants={reduce ? undefined : up}>
          <span className="eyebrow">Vom Betrieb für Betriebe</span>
        </MV>

        <MH
          variants={reduce ? undefined : up}
          className="font-display text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl"
        >
          Planbar neue Aufträge für Ihren{" "}
          <span className="text-[#3DDC97] text-glow">Handwerks- oder Baubetrieb</span>
          {" "}— mit unserem KI-System.
        </MH>

        <MP variants={reduce ? undefined : up} className="mt-6 max-w-2xl text-lg leading-relaxed text-gray-300">
          Kein teures Portal, keine Abhängigkeit von Empfehlungen. Wir bauen Ihnen
          ein System, das rund um die Uhr qualifizierte Anfragen liefert.
        </MP>

        <MV variants={reduce ? undefined : up} className="mt-9 flex flex-col gap-3 sm:flex-row">
          <button
            data-testid="hero-cta-chat"
            onClick={onStartChat}
            className="rounded-md bg-[#3DDC97] px-7 py-4 text-base font-semibold text-[#0E0F12] transition-colors hover:bg-[#2BBF7E] accent-glow"
          >
            In 60 Sekunden prüfen, ob es zu Ihrem Betrieb passt
          </button>
          <button
            data-testid="hero-cta-how"
            onClick={onHowItWorks}
            className="rounded-md border border-white/15 px-7 py-4 text-base font-medium text-gray-200 transition-colors hover:bg-white/5"
          >
            Wie es funktioniert
          </button>
        </MV>

        <MV variants={reduce ? undefined : up} className="mt-4 hidden md:block">
          <p className="mb-2 text-xs text-gray-500">Oder direkt Kontakt aufnehmen:</p>
          <ContactActions size="sm" />
        </MV>

        <MV variants={reduce ? undefined : up} className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-sm text-gray-400">
          {[
            [<Hammer key="h" size={16} />, "Echtes System"],
            [<ShieldCheck key="s" size={16} />, "DSGVO-konform"],
            [<MapPin key="m" size={16} />, "1 Betrieb pro Region"],
          ].map(([icon, label]) => (
            <span key={label} className="flex items-center gap-2">
              <span className="text-[#3DDC97]">{icon}</span> {label}
            </span>
          ))}
        </MV>
      </MV>
    </section>
  );
}
